import { Container } from "./styles"; // styles
import Ronald from "../../assets/profilepicr.jpg";
import kofi from "../../assets/Ko-fi.jpg";
import qr from "../../assets/myQR.jpg";
import wordpress from "../../assets/wordpress.svg";
import coffee from "../../assets/kofi_symbol.svg";
import htmlIcon from "../../assets/html-icon.svg";
import cssIcon from "../../assets/css-icon.svg";
//import sassIcon from "../../assets/sass-icon.svg";
import jsIcon from "../../assets/js-icon.svg";
import nodeIcon from "../../assets/node-icon.svg";
import reactIcon from "../../assets/react-icon.svg";
import typescriptIcon from "../../assets/typescript-icon.svg";
import vueIcon from "../../assets/vue-icon.svg";
import boostrapIcon from "../../assets/bootstrap-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";
import Modal from '../modal/modal'; // Adjust path as needed
import React, { useState } from 'react';
import '../modal/modal.css';


export function About() {

   const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);




  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>About me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <p>
            My name is Ronald Ritz, I'm a Software Engineer with a great
            passion for programming. I am passionate about delivering solutions
            that add to people's lives and at the same time challenge me.
            Improved my skills as a Front-End and Back-End developer
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.2 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
            I develop websites and applications using React, HTML, CSS,
            JavaScript and Typescript. I am familiar with developing layouts
            that they provide me. I'm always improving myself with each project
            I get my hands on.
          </p>
        </ScrollAnimation>



        <ScrollAnimation animateIn="fadeInLeft" delay={0.3 * 1000}>
          <p>
            I am a dedicated person who pursues his dreams, hardworking and
            results oriented, I always seek to achieve my best version.
          </p>
          <br />


  



             <a
                    href="https://ko-fi.com/ritzronald"
                    target="_blank"
                    rel="noreferrer"
                  >      </a>       
          
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={coffee} alt="React" />
            </ScrollAnimation>
<h4> </h4> 
          </div>
          



        </ScrollAnimation>


  <h4><button className="modal-b" onClick={openModal}>How "Buy Me a Coffee" is Transforming...</button></h4>

      <Modal isOpen={isModalOpen} onClose={closeModal} title="Tip me QR pay VS Ko-fi website">
        <p>My Ko-fi account: <p></p>ko-fi.com/ritzronald</p>
        <img className="jedP" src={qr} width="240px" alt="ko-fi" /> 
        
        <img className="jedP fs" src={kofi} width="240px" alt="ko-fi" />  
         
         <a  href="http://ritz.in.net/qrUput.html"><h3>Šta je IPS QR?</h3></a> 
       <br />
       
        <button className="modal-b" onClick={closeModal}>Close</button>
      </Modal>


        <ScrollAnimation animateIn="fadeInLeft" delay={0.4 * 1000}>
          <h3>Here are my main skills:</h3>
        </ScrollAnimation>
        <div className="hard-skills">
          {/* <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
              <img src={wordpress} alt="Wordpress" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.12 * 1000}>
              <img src={shopify} alt="shopify" />
            </ScrollAnimation>
          </div> */}
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.13 * 1000}>
              <img src={reactIcon} alt="React" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.14 * 1000}>
              <img src={typescriptIcon} alt="Typescript" />
            </ScrollAnimation>
          </div>
          {/* <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.15 * 1000}>
              <img src={vueIcon} alt="Vue" />
            </ScrollAnimation>
          </div> */}
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.16 * 1000}>
              <img src={nodeIcon} alt="Node" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.17 * 1000}>
              <img src={htmlIcon} alt="Html" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.18 * 1000}>
              <img src={cssIcon} alt="Css" />
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={boostrapIcon} alt="bootstrap" />
            </ScrollAnimation>
          </div>
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.19 * 1000}>
              <img src={jsIcon} alt="JavaScript" />
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.2 * 1000}>
          <img src={Ronald} alt="Ronald Ritz" />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
